import {
	RES_PROCESS_ASYNC,
	RESPONSIVE_MODE,
} from './constants';



import 'waypoints/lib/noframework.waypoints.min.js';

import { documentQuerySelectorSafe } from '../dpitUtilsPublic';
import DpitBB from './DpitBB';
import { scrollIntoView } from '../../../../../includes/assets/js/modules/dpitUtilsInc';


export const MOB_MENU_STATE = {
	unknown: 'unknown',
	closed: 'closed',
	opened: 'opened',
	triggerOpen: 'triggerOpen',
	triggerClose: 'triggerClose',
	opening: 'opening',
	closing: 'closing',
	scrolling: 'scrolling'
};

export default class DpitMobileMenu {

	constructor(mobileMenuConfig, onUpdateStateCb) {
		this.onUpdateStateCb = onUpdateStateCb;
		this.config = mobileMenuConfig;
		if (this.config.debugEn) console.log('[dpit] INIT DpitMobileMenu');
		this.updateState(MOB_MENU_STATE.unknown);

	}

	fixAdminMobMenuFocusOut() {
		// WordPress is in common.js closing admin bar menu when it loose a focus
		if (!this.isAdminMenuToggleFocusFix) {
			this.isAdminMenuToggleFocusFix = true;
			$('#wp-admin-bar-menu-toggle, #adminmenumain').off('focusout');
		}
	}

	getCloserElementSelector() {
		return this.config.mobile_menu_closer ? this.config.mobile_menu_closer : this.config.mobile_menu_opener;
	}

	toggleClose(mobileMenuChildEl) {
		const closerEl = documentQuerySelectorSafe(this.getCloserElementSelector());
		if (closerEl) {
			this.fixAdminMobMenuFocusOut();
			$(closerEl).trigger('click');
			return this.isInTransition(mobileMenuChildEl);
		} else {
			return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
	}

	toggleOpen(mobileMenuChildEl) {
		const openerEl = documentQuerySelectorSafe(this.config.mobile_menu_opener);
		if (openerEl) {
			this.fixAdminMobMenuFocusOut();
			$(openerEl).trigger('click');
			return this.isInTransition(mobileMenuChildEl);
		} else {
			return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
	}

	updateState(state) {
		if (state !== this.state) {
			if (this.config.dpDebugEn) console.log('[dpit] Mob. MENU updated state to:', state);
			const prevState = this.state;
			this.state = state;
			const isInTransition = state === MOB_MENU_STATE.opening || state === MOB_MENU_STATE.closing;
			if (this.onUpdateStateCb instanceof Function) this.onUpdateStateCb(state, prevState, isInTransition);
		}
	}

	clearInTransitionData() {
		this.isOverInsensitivity = false;
		clearTimeout(this.insensitivityTimeout);
		this.insensitivityTimeout = null;
	}

	isInTransition(mobileMenuChildEl, timeoutMs = 100) {
		if (!mobileMenuChildEl) {
			return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
		return new Promise((resolve) => {
			//let timeStarted = Date.now();
			let same = 0; // a counter
			let lastPos = null; // last known bounding box

			let isFinished = false;
			this.clearInTransitionData();
			// this function will be called every painting frame
			// for the duration of the smooth scroll operation
			const check = () => {
				if (isFinished) {
					isFinished = true;
					return resolve(RES_PROCESS_ASYNC.abort);
				}
				// check our current position
				const newPos = DpitBB.fromElement(mobileMenuChildEl, this.isFixedPos);

				if (lastPos && DpitBB.isEqual(newPos, lastPos)) { // same as previous
					same++;
					if (same > 15) { // ish 250ms
						if (this.isOverInsensitivity && this.insensitivityTimeout) {
							this.clearInTransitionData();
							isFinished = true;
							return resolve(RES_PROCESS_ASYNC.continue);
						}
						else if (!this.insensitivityTimeout) {
							this.insensitivityTimeout = setTimeout(() => {
								this.isOverInsensitivity = true;

								requestAnimationFrame(check);
							}, timeoutMs);
						}
					}
				}
				else {
					same = 0; // reset our counter
					lastPos = { ...newPos }; // remember our current position
					//timeStarted = Date.now();
					this.clearInTransitionData();
				}
				//if (Date.now() - timeStarted > timeoutMs) return resolve(RES_PROCESS_ASYNC.timeout);
				// check again next painting frame
				if (!isFinished) requestAnimationFrame(check);
			};
			// let's begin
			requestAnimationFrame(check);
		});
	}


	iterateStateAsOpening(state, mobMenuChildElement) {
		this.updateState(state);
		return this.updateMachineAsOpening(mobMenuChildElement);
	}

	async updateMachineAsOpening(mobMenuChildElement) {
		switch (this.state) {

			case MOB_MENU_STATE.unknown:
			case MOB_MENU_STATE.closed:
				if (documentQuerySelectorSafe(this.config.mobile_menu_opener)) {
					this.state = MOB_MENU_STATE.scrolling;
					this.scrollToMobileMenuOpener();
					return this.iterateStateAsOpening(MOB_MENU_STATE.triggerOpen, mobMenuChildElement);
				}
				else return Promise.resolve(RES_PROCESS_ASYNC.continue);
			case MOB_MENU_STATE.triggerOpen: {
				this.updateState(MOB_MENU_STATE.opening);
				const toggleMobileMenuOpenRes = await this.toggleOpen(mobMenuChildElement);
				switch (toggleMobileMenuOpenRes) {
					case RES_PROCESS_ASYNC.timeout:
					case RES_PROCESS_ASYNC.continue:
						return this.iterateStateAsOpening(MOB_MENU_STATE.opened, mobMenuChildElement);
				}
				return Promise.resolve(toggleMobileMenuOpenRes);
			}
			case MOB_MENU_STATE.scrolling:
			case MOB_MENU_STATE.opening:
			case MOB_MENU_STATE.opened:
			default: return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
	}

	iterateStateAsClosing(state, mobMenuChildElement) {
		this.updateState(state);
		return this.updateMachineAsClosing(mobMenuChildElement);
	}



	async updateMachineAsClosing(mobMenuChildElement) {
		switch (this.state) {
			//case MOB_MENU_STATE.unknown:
			case MOB_MENU_STATE.opened:
				if (documentQuerySelectorSafe(this.getCloserElementSelector())) {
					return this.iterateStateAsClosing(MOB_MENU_STATE.triggerClose, mobMenuChildElement);
				}
				else return Promise.resolve(RES_PROCESS_ASYNC.continue);
			case MOB_MENU_STATE.triggerClose: {
				this.updateState(MOB_MENU_STATE.closing);
				const toggleMobileMenCloseRes = await this.toggleClose(mobMenuChildElement);
				switch (toggleMobileMenCloseRes) {
					case RES_PROCESS_ASYNC.timeout:
					case RES_PROCESS_ASYNC.continue:
						return this.iterateStateAsClosing(MOB_MENU_STATE.closed, mobMenuChildElement);
				}
				return Promise.resolve(toggleMobileMenCloseRes);
			}
			case MOB_MENU_STATE.closing:
			case MOB_MENU_STATE.closed:
			default: return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
	}


	updateMachine(stepElement, prevStepElement, isTargetInMobileMenu, isMobileSize) {

		if (stepElement && !(stepElement instanceof Element)) {
			return Promise.reject(new Error('Argument 1 must be an Element'));
		}

		const isActiveMobileMenuAlt = isMobileSize
			&& (isTargetInMobileMenu || this.forceResponsiveMode === RESPONSIVE_MODE.mobileMenu)
			&& this.forceResponsiveMode !== RESPONSIVE_MODE.desktop;

		if (isActiveMobileMenuAlt /*&& [MOB_MENU_STATE.closed, MOB_MENU_STATE.closing, MOB_MENU_STATE.unknown].includes(this.state)*/) {
			return this.updateMachineAsOpening(stepElement);
		}
		else if (/*prevStepElement && */[MOB_MENU_STATE.opened, MOB_MENU_STATE.opening].includes(this.state)) {
			return this.updateMachineAsClosing(prevStepElement);
		}
	}


	async scrollToMobileMenuOpener() {
		if (this.config.mobile_menu_opener) {
			const mmOpenerEl = documentQuerySelectorSafe(this.config.mobile_menu_opener);
			if (mmOpenerEl) {
				//if (isElementInsideContainer(mmOpenerEl, getWinBB(),  ))
				//this.softenOverlayOpacity(0);
				await scrollIntoView(mmOpenerEl);
				//animateElement(mmOpenerEl, 'dpit-bullet-pulse', 200);
				//await asyncWait(100);
				//this.softenOverlayOpacity();
			}
		}
	}

	async forceOpen() {
		await this.iterateStateAsOpening(MOB_MENU_STATE.triggerOpen, null);
	}

	update(stepElement, isTargetInMobileMenu, isFixedPos, isMobileSize, prevStepElement) {
		this.isFixedPos = isFixedPos;
		if (this.config.mobile_menu_opener) {
			try {
				return this.updateMachine(
					stepElement,
					prevStepElement,
					isTargetInMobileMenu,
					isMobileSize,
					this.forceResponsiveMode
				);
			} catch (exc) {
				console.error('[dpit] Mob. MENU ', exc);
				return Promise.resolve(RES_PROCESS_ASYNC.continue);
			}
		} else {
			return Promise.resolve(RES_PROCESS_ASYNC.continue);
		}
	}

	clear(currentStepItem) {
		if ((this.state === MOB_MENU_STATE.opened || this.state === MOB_MENU_STATE.opening) && currentStepItem) {
			if (this.config.dpDebugEn) console.log('[dpit] Mob. MENU Closing ... ');
			return this.updateMachineAsClosing(currentStepItem.element);
		}
		return Promise.resolve(RES_PROCESS_ASYNC.continue);
	}
}
